import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js'
import moment from 'moment'
import download from 'downloadjs'
import Loader from './../shared/loader'
import Pagination from './../shared/pagination'
// import Vue from "vue";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import {
	Validator
} from 'vee-validate'

export default {
	name: 'stockgrnreport',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		download,
		JsonExcel,
		Loader
	},
	data: function () {
		return {
			isLoadingforxls: false,
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			listStockGrnData: [],
			listStockGrnDataCsv: [],
			listWarehouseData: [],
			listuserData: [],
			csvFields: [],
			datenow: '',
			isLoading: false,
			searchFlag: false,
			loginwarehouseid: '',
			Warehouse_obj: '',
			resultCount: '',
			listClientData: [],
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			ClientErr: '',
			UidErr: '',
			WarehouseErr: '',
			showSelectWarehouse: false,
			showSelectClient: false,
			user_type: '',
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			userid: '',
			recordLimit: 0,
			limitExeed: false,
            srno:'',
            status:'',
            fromDateFlt:'',
            toDateFlt:'',
			itemcode:'',
			formattedDate: '',
			currentDate:'',
			FromdateErr:'',
			todateErr:''
		}
	},
	created: function () { },
	// when a page loads,mounted() will be call
	mounted() {

		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = userdetail.userid;
		this.userid = userdetail.userid;
		this.createdbyEmail = userdetail.email;
		this.reportname = this.$t('stockgrn.stockGrnReport'),
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.calldateFunction()
		this.getRecordLimit()
	},
	methods: {
		calldateFunction() {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 6);
			this.toDateFlt = this.currentDate;
			this.fromDateFlt = dt;

		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		Choosetype() {
			this.show = true;
			this.download = false;			
			if (!this.limitExeed) {	
				this.getGrnReportDataXLS()
			}
		},
		jsonToCSV(filename, data, csvfield, dateFilter = [], skipFilter = [], dataFilter) {
			var csvData = '';
			//Header
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			//Fields
			csvData += ''
			Object.entries(dataFilter).forEach(([k, v]) => {
				csvData += k + ':' + v + ','
			})
			csvData += '\r\n'
			csvData += '\r\n'

			for (let key in data[0]) {
				if (skipFilter.indexOf(key) == -1)
					csvData += csvfield[key] + ',';
			}
			csvData = csvData.slice(0, csvData.length - 1);
			csvData += '\r\n';
			//Data
			data.map(function (item) {
				for (let key in item) {
					if (skipFilter.indexOf(key) == -1) {
						var escapedCSV = item[key] + ''; // cast Numbers to string
						if (escapedCSV.match(/[,"\n]/)) {
							escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
						}
						if (escapedCSV == 'null')
							csvData += ',';
						else {
							if (dateFilter.indexOf(key) != -1)
								csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ',';
							else
								csvData += escapedCSV + ',';
						}
					}
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			})
			//Footer
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n');
			}
			filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
			return this.export(csvData, filename, "application/csv");
			return csvData;
		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		// clientSelected() {

		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;

		// 		if (this.user_type != 'warehouse_user') {
		// 			this.totalRows = 0
		// 			this.listStockGrnData = []
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {

		// 			if (this.warehouseid && this.clientid);
		// 			// this.getDataTransmissinreportData();
		// 		}
		// 	}

		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	this.listStockGrnData = [];
		// 	this.totalRows = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// console.log(this.warehouse);
		// 			// this.getDataTransmissinreportData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD 00:00:00');
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD 23:59:00');
		},
		getGrnReportrSearch(){
			this.currentPage = 1;
			this.getGrnReportData(2);
		},
		//to get Stock list
		getGrnReportData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.ClientErr = '';
			var dataFilter =[];
			this.resultCount = 0
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageno = this.totalPage = 0;
				this.listStockGrnData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageno = this.totalPage = 0;
				this.listStockGrnData = [];
				return false;
			}
			if (this.fromDateFlt == '' || this.fromDateFlt == null) {
				this.FromdateErr = this.$t('returnReceiptReport.fromDateFlterError');
				return false
			}
			if (this.toDateFlt == '' || this.toDateFlt == null) {
				this.todateErr = this.$t('returnReceiptReport.ToDateFlterError');
				return false
			}
			if (this.srno) {
				this.srno = this.srno
			}
			this.isLoading = true;
			this.input = ({
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
                serialnumber: this.srno,
				status: this.status,
				itemcode:this.itemcode,
				fromdate: this.dateFormat(this.fromDateFlt),
				todate: this.dateFormat2(this.toDateFlt),
				offset: (this.currentPage - 1) * 10,
				limit: 10,
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'airtel/getStockGRNReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
						this.listStockGrnData = result.data.data;
						if (result.data.errorCode == -1) {
							this.resultCount = 0
							this.totalRows = 0
						} else {
							this.searchFlag= true;
							this.totalRows = Number(result.data.count);
							this.resultCount = Number(result.data.count);
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							if (this.totalRows < 10) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / 10)
							}
						}
					// }
					this.isLoading = false;
				},
					error => {
						console.error(error)
					})

		},
		getGrnReportDataCSV() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var dataFilter =[];
				if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageno = this.totalPage = 0;
				this.listStockGrnData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageno = this.totalPage = 0;
				this.listStockGrnData = [];
				return false;
			}
			if (this.srno) {
				this.srno = this.srno
			}
			this.isLoading = true;
			this.input = ({
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
                serialnumber: this.srno,
				status: this.status,
				itemcode:this.itemcode,
				fromdate: this.dateFormat(this.fromDateFlt),
				todate: this.dateFormat2(this.toDateFlt),
				userid: this.userid
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'airtel/getStockGRNReportCSV',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data.data.length > 0) {
							this.csvFields = {
								'warehousename':this.$t('common.warehouse'),
								'itemcode': this.$t('importCsv.itemcode'),
								'serialnumber': this.$t('stockgrn.srno'),
								'zonename': this.$t('stockgrn.circlename'),
								'quantity': this.$t('bundlePacking.scannedqty'),
								'received_qty': this.$t('editedjson.receivedQty'),
								'difference_qty': this.$t('inventoryReconciliationReport.difference'),
								'grnby':this.$t('stockgrn.grnby'),
					            'grndate':this.$t('stockgrn.grnDate'),
								'grnstatus':this.$t('common.status'),
								'grnclosedate':this.$t('stockgrn.grnclosedate')
							};
							var dateFilder = [];
							var skipFilter = ['full_count','uploadeddate','createdby'];
							this.listStockGrnDataCsv = result.data.data;
							this.jsonToCSV(this.$t('stockgrn.stockGrnReport'), this.listStockGrnDataCsv, this.csvFields, dateFilder, skipFilter, dataFilter);
						    this.isLoading = false;
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
				}, error => {
					console.error(error)
					this.isLoading = false;
				});
		},
		getGrnReportDataXLS(){
		   var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.ClientErr = '';
			var dataFilter =[];
			if (window.localStorage.getItem('selectedClient')==='undefined') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageno = this.totalPage = 0;
				this.listStockGrnData = [];
				return false;
			}
			if (window.localStorage.getItem('selectedWarehouse')==='undefined') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageno = this.totalPage = 0;
				this.listStockGrnData = [];
				return false;
			}
			if (this.srno) {
				this.srno = this.srno
			}
			this.isLoading = true;
			this.input = ({
				clientid: window.localStorage.getItem('selectedClient'),
				warehouseid: window.localStorage.getItem('selectedWarehouse'),
                serialnumber: this.srno,
				status: this.status,
				itemcode:this.itemcode,
				fromdate: this.dateFormat(this.fromDateFlt),
				todate: this.dateFormat2(this.toDateFlt),
				userid: this.userid
			})
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'airtel/getStockGRNReportCSV',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
			.then(result => {
				if (result.data.data.length > 0) {	
					this.listReportDataforxls = [];
					this.csvFieldsForXls[this.$t('importCsv.itemcode')]= 'itemcode';
					this.csvFieldsForXls[this.$t('stockgrn.srno')]= 'serialnumber';
					this.csvFieldsForXls[this.$t('stockgrn.circlename')]= 'zonename';
					this.csvFieldsForXls[this.$t('bundlePacking.scannedqty')]= 'quantity';
					this.csvFieldsForXls[this.$t('editedjson.receivedQty')]= 'received_qty';
					this.csvFieldsForXls[this.$t('inventoryReconciliationReport.difference')]= 'difference_qty';							
					this.csvFieldsForXls[this.$t('stockgrn.grnby')]= 'grnby';
					this.csvFieldsForXls[this.$t('stockgrn.grnDate')]= 'grndate';
					this.csvFieldsForXls[this.$t('common.status')]= 'grnstatus';	
					this.csvFieldsForXls[this.$t('stockgrn.grnclosedate')]= 'grnclosedate';						
					this.listReportDataforxls = result.data.data;
					this.isLoading = false;	
				} else {
					if (result.data.status == true) {
						this.$alertify.success(this.$t('common.reportSizeError'));
					} else {
						this.$alertify.error(result.data.msg.message);
					}
				}
			});
		},
		//to reset search form
		resetForm() {
			this.show = false;
			this.download = true;
			this.totalRows = 0
			this.serialnumber =''
			this.listStockGrnData = [];
			this.pageno = this.totalPage = 0;
			this.searchFlag = false;
			// this.getDataTransmissinreportData();
			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
		},
		onPageChange(page) {
			this.currentPage = page;
			this.getGrnReportData()
		},
	}
}


// WEBPACK FOOTER //
// ./src/views/components/stockGrnReport/stockgrnreport.component.js